import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaBanner({
  eyebrow = "Ready when you are",
  title = "Find out if your business qualifies",
  body = "Share a few details about your business and site — we'll assess whether a no-upfront solar and battery energy plan may suit you.",
  ctaLabel = "Start online application",
  ctaTo = "/apply",
  secondaryLabel = "Talk to Be Green Group",
  secondaryTo = "/contact",
  testId = "cta-banner",
}) {
  return (
    <section className="container-x mx-auto max-w-7xl py-16 md:py-24" data-testid={testId}>
      <div className="relative overflow-hidden rounded-3xl bg-forest-gradient text-white p-8 md:p-14 grain">
        <div className="max-w-3xl">
          <p className="text-bright text-xs md:text-sm tracking-[0.18em] uppercase font-semibold mb-4">{eyebrow}</p>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold leading-[1.05]">{title}</h2>
          <p className="text-white/75 text-base md:text-lg mt-5 max-w-2xl leading-relaxed">{body}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to={ctaTo}
              data-testid={`${testId}-primary`}
              className="inline-flex items-center gap-2 bg-bright text-[hsl(150_40%_8%)] rounded-full px-6 h-12 font-semibold hover:brightness-105 transition"
            >
              {ctaLabel} <ArrowRight size={18} />
            </Link>
            <Link
              to={secondaryTo}
              data-testid={`${testId}-secondary`}
              className="inline-flex items-center gap-2 rounded-full px-6 h-12 font-medium text-white border border-white/25 hover:bg-white/10 transition"
            >
              {secondaryLabel}
            </Link>
          </div>
        </div>
        <div
          aria-hidden
          className="hidden md:block absolute -right-16 -top-16 h-72 w-72 rounded-full"
          style={{ background: "radial-gradient(closest-side, hsl(140 80% 40% / 0.4), transparent 70%)" }}
        />
      </div>
    </section>
  );
}
